<template>
  <div
    class="search-results"
    :class="sectionClass"
  >
    <p class="title subtitle-case">{{ title }}</p>
    <slot />
  </div>
</template>

<script setup lang="ts">
  withDefaults(
    defineProps<{
      title: string
      sectionClass?: string
    }>(),
    {
      sectionClass: '',
    },
  )
</script>

<style lang="scss" scoped>
  .title {
    color: $orange;
    margin-bottom: var(--margin-md);
    font-size: var(--text-small);
  }
</style>
